function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 14.2982C3.55228 14.2982 4 14.7459 4 15.2982V19.2982C4 19.5634 4.10536 19.8178 4.29289 20.0053C4.48043 20.1929 4.73478 20.2982 5 20.2982H19C19.2652 20.2982 19.5196 20.1929 19.7071 20.0053C19.8946 19.8178 20 19.5634 20 19.2982V15.2982C20 14.7459 20.4477 14.2982 21 14.2982C21.5523 14.2982 22 14.7459 22 15.2982V19.2982C22 20.0939 21.6839 20.8569 21.1213 21.4195C20.5587 21.9821 19.7957 22.2982 19 22.2982H5C4.20435 22.2982 3.44129 21.9821 2.87868 21.4195C2.31607 20.8569 2 20.0939 2 19.2982V15.2982C2 14.7459 2.44772 14.2982 3 14.2982Z",
  fill: "#189BC5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.29289 9.59111C6.68342 9.20059 7.31658 9.20059 7.70711 9.59111L12 13.884L16.2929 9.59111C16.6834 9.20059 17.3166 9.20059 17.7071 9.59111C18.0976 9.98164 18.0976 10.6148 17.7071 11.0053L12.7071 16.0053C12.3166 16.3958 11.6834 16.3958 11.2929 16.0053L6.29289 11.0053C5.90237 10.6148 5.90237 9.98164 6.29289 9.59111Z",
  fill: "#189BC5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.29822C12.5523 2.29822 13 2.74593 13 3.29822V15.2982C13 15.8505 12.5523 16.2982 12 16.2982C11.4477 16.2982 11 15.8505 11 15.2982V3.29822C11 2.74593 11.4477 2.29822 12 2.29822Z",
  fill: "#189BC5"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.f2423c18.svg";
export { ForwardRef as ReactComponent };